
export const GET_CITY = "GET_CITY";
export const GET_CITY_FAILURE = "GET_CITY_FAILURE";
export const GET_CITY_SUCCESS = "GET_CITY_SUCCESS";